import * as React from 'react';

import SimplifiedHeader from 'bundles/composable-page-header-consumer/header-renderers/SimplifiedHeader';
import UniversalPageFeatures from 'bundles/composable-page-header/components/UniversalPageFeatures';
import PageFooter from 'bundles/page-footer/components/PageFooter';
import NotFound from 'bundles/phoenix/components/NotFound';

import 'css!bundles/about/components/styl/AboutApp';

export default function AboutApp({ children }: { children: React.ReactNode }) {
  return (
    <div className="rc-AboutApp coursera-body">
      <SimplifiedHeader showProgramSwitcher={false} showAcctItemsInMain />
      <UniversalPageFeatures />
      <div className="bt3-container c-about-canvas-container" role="main">
        <div className="coursera-full-canvas">
          <div className="coursera-about-body">{children || <NotFound />}</div>
        </div>
      </div>
      <PageFooter />
    </div>
  );
}
